// components/SalesTypeModal.jsx
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Dropdown } from '@pw-tech/omni-ui'
import UserModal from '@assets/images/ambassdor/UserModal'
import { useNavigate } from 'react-router-dom'
import { Client } from '@api/index'

export default function BatchSales({ isOpen, onClose, title, description }: any) {
    const [batchSalesType, setBatchSalesType] = useState<any>([])
    const [categories, setCategories] = useState<any>([])
    const [exams, setExams] = useState([])
    const [examsData, setExamsData] = useState([])
    const [classList, setClassList] = useState<any>([])
    const examRef = useRef<string>("")
    const selectedBatchRef = useRef<string>("")
    const [cohortId, setCohortId] = useState<string>("")

    const navigate = useNavigate()
    const getClients = async () => {
        const params: any = {
            orgFeatType: "ASSISTED_SALES",
            fields: "name,orgId"
        }
        const response = await Client.get(`${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/clients`, { params: params })
        getCategories(response?.data?.data?.[0]?.orgId)
    }

    const getLabel = (name: string) => {
        if (name === "VP_LIVE") return "Power Batch"
        if (name === "NORMAL") return "Online"
        if (name === "OFFLINE") return "Offline"
        return name
    }

    const getCategories = async (orgId: string) => {
        const params: any = {
            type: "BATCH",
            orgId: orgId
        }
        const response = await Client.get(`${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/categories`, { params: params })
        setCategories(response?.data?.data)
        const batchSalesType = response?.data?.data?.map((item: any) => ({
            label: getLabel(item?.name),
            value: item?.name
        }))
        setBatchSalesType(batchSalesType)
    }

    const getExams = async (selectedBatch: string) => {
        selectedBatchRef.current = selectedBatch
        const categoryId = categories?.find((item: any) => item?.name === selectedBatch)?._id
        const params: any = {
            type: "ASSISTED_SALES",
            categoryId: categoryId
        }
        const response = await Client.get(`${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/categories-org-mapping/cohort-list?`, { params: params })
        const exams = response?.data?.data?.map((item: any) => ({
            label: item?.exam || "",
            value: item?.exam || ""
        }))
        setExamsData(response?.data?.data)
        setExams(exams)
    }

    const getClass = (selectedExam: string) => {
        setCohortId("")
        examRef.current = selectedExam
        const examObject: any = examsData?.find((item: any) => item?.exam === selectedExam)
        const classObject: any = examObject?.cohorts || []
        const classes = classObject
            ?.filter(
                (item: any) =>
                    item?.class || item?.stream || item?.board || item?.language
            )
            .map((item: any) => ({
                label: item.class || item.stream || item.board || item.language,
                value: item.class || item.stream || item.board || item.language,
            }));
        if (classes?.length === 0) {
            setCohortId(examObject?.cohorts?.[0]?._id)
        }
        setClassList(classes)
    }

    const getCohortId = (selectedClass: string) => {
        const examObject: any = examsData?.find((item: any) => item?.exam === examRef?.current)
        const classCohorts: any = examObject?.cohorts || []
        const classObject = classCohorts?.find((item: any) => (item?.class || item?.stream || item?.board || item?.language) === selectedClass)
        setCohortId(classObject?._id || "")
    }

    const getTag = () => {
        if (selectedBatchRef?.current === "NORMAL") return "online"
        if (selectedBatchRef.current === "OFFLINE") return "offline"
        if (selectedBatchRef.current === "VP_LIVE") return "premium"
        return selectedBatchRef.current || ""
    }

    useEffect(() => {
        const fetchData = async () => {
            await getClients()
        }
        fetchData()
    }, [])

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[5000]" onClose={() => { }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-[420px] transform rounded-2xl bg-white p-6 shadow-xl transition-all">
                                <div className="flex justify-between items-center mb-4">
                                    <Dialog.Title className="text-xl font-semibold text-gray-900">{title}</Dialog.Title>
                                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                </div>

                                <div className="flex flex-col items-center space-y-4">
                                    <UserModal />
                                    <p className="text-[#757575] text-sm text-center">{description}</p>
                                </div>
                                <div className='flex flex-col gap-4 mt-6'>
                                    <Dropdown
                                        label="Batch Type"
                                        onChange={(e) => { getExams(e?.target?.value) }}
                                        onClick={() => { }}
                                        options={batchSalesType}
                                        placeholder="Select Batch Type"
                                        fullWidth
                                    />
                                    <Dropdown
                                        label="Exam"
                                        onChange={(e: any) => { getClass(e?.target?.value) }}
                                        onClick={() => { }}
                                        options={exams}
                                        placeholder="Select Exam"
                                        fullWidth
                                    />
                                    {classList?.length > 0 && <Dropdown
                                        label="Class"
                                        onChange={(e: any) => { getCohortId(e?.target?.value) }}
                                        onClick={() => { }}
                                        options={classList}
                                        placeholder="Select Class"
                                        fullWidth
                                    />}
                                </div>
                                <div className='mt-6 flex items-center gap-3 justify-end'>
                                    <div className='max-w-[132px]'>
                                        <Button onClick={onClose} variant='secondary' fullWidth>Cancel</Button>
                                    </div>
                                    <div className='max-w-[132px]'>
                                        <Button onClick={() => { navigate(`/sales/batch-listing?cohortId=${cohortId}&tag=${getTag()}`), onClose() }} variant='primary' fullWidth disabled={!cohortId}>Explore</Button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition >
    )
}
